export function cleanTweetURL(url) {

    let cleanedUrl = new URL(url);

    // Remplacer x.com par twitter.com
    if (cleanedUrl.host === "x.com") {
     cleanedUrl = new URL(url.replace("x.com", "twitter.com"));
    }

    return `${cleanedUrl.protocol}//${cleanedUrl.host}${cleanedUrl.pathname}`;
  }